<template>
  <div class="address-page">
    <div class="header">
      <div class="back-arrow" @click="goBack">
        <i class="fas fa-arrow-left"></i>
      </div>
      <div class="title">收货地址</div>
      <div class="button-container">
        <button class="manage-btn" @click="toggleManage">
          <el-icon :size="20" v-if="isManaging"><CircleCheckFilled /></el-icon>
          <el-icon :size="20" v-else><Setting /></el-icon>
          {{ isManaging ? "完成" : "管理" }}
        </button>
        <!-- <button class="add-btn" @click="addAddress">
          <el-icon :size="20"><Plus /></el-icon>
          新增地址
        </button> -->
        <!-- 添加地址按钮 -->
     <!-- 添加地址按钮 -->
     <button class="add-btn" @click="addAddress">
      <el-icon :size="20"><Plus /></el-icon>
      新增地址
    </button>
      </div>
    </div>

     <!-- 新增地址模态框 -->
     <div v-if="showAddAddressModal" class="modal">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <div class="map-container">
        <!-- 高德地图定位地址 -->
        <div id="map"></div>
      </div>
      <form @submit.prevent="submitNewAddress">
        <input type="text" placeholder="所在地区省" v-model="address.province" />
        <input type="text" placeholder="所在市" v-model="address.city" />
        <input type="text" placeholder="所在区" v-model="address.area" />
        <input type="text" placeholder="所在街道" v-model="address.street" />
        <input type="text" placeholder="详细地址和门牌号" v-model="address.detailedAddress" />
        <input type="text" placeholder="收货人姓名" v-model="address.userName" />
        <input type="tel" placeholder="手机号" v-model="address.mobileNo" />
        <button type="submit">保存地址</button>
      </form>
    </div>
  </div>

    <div class="address-list">
      <div
        v-for="(address, index) in addresses"
        :key="index"
        class="address-item"
        :class="{ 'default-address': address.isDefault }"
        @click="checkoutAddress(address.id)"
      >
        <div class="address-info">
            <div class="address-info-1">
                <div class="info-line">
                <span class="address-province-span" :class="address.isDefault ? 'default-address-province-span' : 'non-default-address-province-span'">{{ address.province }} {{ address.city }} {{ address.area }} {{ address.street }}</span>
            </div>
            <div class="info-line">
                <span class="address-detailed-span" :class="address.isDefault ? 'default-address-detailed-span' : 'non-default-address-detailed-span'">{{ address.detailedAddress }}</span>
            </div>
            <div class="info-line info-last-line">
                <span class="address-user-span" :class="address.isDefault ? 'default-address-user-span' : 'non-default-address-user-span'">{{ address.username }} {{ address.mobileNo }}</span>
                <span :class="{'address-default-span' : address.isShowDefault }">{{ address.isShowDefault ? "默认" : ""}}</span>
            </div>
            </div>
            <div class="address-info-2">
                <button class="edit-btn" :class="address.isDefault ? 'default-background' : 'non-default-background'" @click.stop="editAddress(address.id)">
                    <el-icon :size="23"><Edit /></el-icon>
                </button>
            </div>
            
        </div>
        <div v-if="isManaging" class="manage-actions">
          <button class="action-btn" @click="deleteAddress(index)">删除</button>
          <button class="action-btn" @click="copyAddress(address)">复制</button>
          <button class="action-btn" @click="setDefaultAddress(index)">
            设为默认
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { ref,getCurrentInstance,onMounted,computed } from "vue";
import { useRoute,useRouter } from "vue-router"; 
import { Setting, CircleCheckFilled, Plus ,Edit} from "@element-plus/icons-vue";

export default {
  components: {
    Setting,
    CircleCheckFilled,
    Plus,
    Edit
  },
  setup() {
    const addresses = ref([
    ]);
    const address = ref({
      province: '',
      city: '',
      area: '',
      street:'',
      detailedAddress: '',
      userName: '',
      mobileNo: '',
      addressType: '2'
    });
    const isManaging = ref(false);
    const showAddAddressModal = ref(false);
    const operateType = ref('');
    const addressId = ref('');
     const { proxy } = getCurrentInstance();
     const route = useRoute(); // 获取当前路由信息
     const id = route.params.id; // 获取传递的 id
     const router = useRouter();

    const addAddress = () => {
        
      showAddAddressModal.value = true;
      operateType.value = '1';
    };

    const editAddress = (id) => {
        
        showAddAddressModal.value = true;
        operateType.value = '2';
        addressId.value = id;
      };

    const closeModal = () => {
      showAddAddressModal.value = false;
    };

    const submitNewAddress = async () => {
      let operateTypeParam = operateType.value;
      let addressIdParam = addressId.value;
      let reqBodyWithOperateType = {
        ...address.value, // 展开address.value中的所有属性
        operateType: operateTypeParam, // 添加新的 operateType 参数
        addressId : addressIdParam
};
        const url = '/user/addAddress';
        proxy.$tools.request(url,{reqBody:reqBodyWithOperateType}).then(response =>{
            console.log("请求添加地址的结果："+JSON.stringify(response.data))
        }).catch(error => {
            console.error(error);
        });
        // queryAllAddress();
      closeModal(); // 提交后关闭模态框
      window.location.reload();
    };

    function checkoutAddress(id) {
     router.push({name:"SubmitOrderWithParam",params:{id:id}}); // 使用 router.push 方法跳转到其他页面
}



    const queryAllAddress = async () => {
        const url = '/user/queryAllAddress';
        proxy.$tools.request(url,{reqBody:{addressType:'2',addressId : id}}).then(response =>{
            addresses.value = response.data.rspBody.userAddressList;
        }).catch(error => {
            console.error(error);
        });
      closeModal(); // 提交后关闭模态框
    };

     // 使用计算属性来处理地址列表
     const processedAddresses = computed(() => {
      return addresses.value.map(address1 => {
        // 如果 isDefault 字段的值为 1，则设置为 true，否则设置为 false
        return {
          ...address1,
          isDefault: address1.id.toString() === id,
          isShowDefault : address1.isDefault === '1'
        };
      });
    });
    
    const goBack = () => {
      // 返回上一页的逻辑
      router.go(-1);
      console.log("返回上一页");
    };

    const toggleManage = () => {
      isManaging.value = !isManaging.value;
    };

    const deleteAddress = (index) => {
      addresses.value.splice(index, 1);
    };

    const copyAddress = (address) => {
      // 复制地址的逻辑
      console.log("复制地址", address);
    };

    const setDefaultAddress = (index) => {
      addresses.value.forEach((addr, idx) => {
        addr.isDefault = idx === index;
      });
    };

    // const editAddress = (address) => {
    //   // 编辑地址的逻辑
    //   console.log("编辑地址", address);
    // };

    onMounted (() =>{
        queryAllAddress();
    });

    return {
      isManaging,
      goBack,
      toggleManage,
      addAddress,
      deleteAddress,
      copyAddress,
      setDefaultAddress,
      editAddress,
      submitNewAddress,
      showAddAddressModal,
      closeModal,
      address,
      checkoutAddress,
      addresses: processedAddresses
    };
  },
};
</script>
  
  <style scoped>
.address-page {
  font-family: "Arial", sans-serif;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 15px;
  border-bottom: 1px solid #eaeaea;
}

.button-container {
  display: flex; /* 设置为flex布局 */
  justify-content: flex-end; /* 根据需要调整对齐方式 */
  align-items: center; /* 保持按钮垂直居中对齐 */
}

.manage-btn {
  display: flex;
  align-items: center; /* 保持图标和文字垂直居中对齐 */
  gap: 4px; /* 减小图标和文字之间的间隔 */
  border: none;
  background: none;
  color: #ff680a;
  font-weight: bold;
  font-size: 16px;
  margin-right: 11px;
  /* 其他按钮样式保持不变 */
}
.add-btn {
  display: flex;
  align-items: center; /* 保持图标和文字垂直居中对齐 */
  gap: 4px; /* 减小图标和文字之间的间隔 */
  border: none;
  background: none;
  color: #ff680a;
  font-weight: bold;
  font-size: 16px;
  /* 其他按钮样式保持不变 */
}

/* 你可以针对图标本身进行样式调整，例如调整大小 */
.el-icon {
  /* size: 24px; */
  width: 1em; /* 或者其他适合的大小 */
  height: 1em; /* 保持图标大小一致 */
}

.back-arrow {
  cursor: pointer;
  font-size: 20px;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-left: -100px;
}


/* 模态框样式 */
.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  margin: 0; /* 移除外边距 */
  padding: 20px;
  border: 1px solid #888;
  width: 100%; /* 宽度设置为100%，填满整个屏幕宽度 */
  max-width: none; /* 移除最大宽度限制 */
  height: 80%; /* 设置高度为视口高度的80% */
  max-height: 700px; /* 设置最大高度，适用于小屏幕设备 */
  box-sizing: border-box; /* 确保padding和border包含在宽度内 */
}

.map-container {
  height: 33%; /* 页面最上方的三分之一显示地图 */
}

#map {
  width: 100%;
  height: 100%;
}

input[type="text"],
input[type="tel"] {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ddd;
  box-sizing: border-box;
}

button[type="submit"] {
  width: 100%;
  padding: 10px;
  background-color: #5cb85c;
  color: white;
  border: none;
  cursor: pointer;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.actions button {
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 16px;
  padding: 5px 10px;
  margin-left: 10px;
}

.address-list {
  padding: 15px;
}

.address-item {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 15px;
  margin-bottom: 15px;
}

.address-info {
  font-size: 16px;
  /* flex-direction: column; */
  margin-bottom: 10px;
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  justify-content: space-between; /* 水平分散对齐 */
  /* display: flex;
  align-items: center; */
}

.info-line{
    margin-bottom:8px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap; /* 允许子元素换行 */
}

.default-address-province-span{
    color: rgba(253, 123, 17, 0.879);
}

.non-default-address-province-span{
    color: rgba(120, 116, 111, 0.879);
}

.address-province-span{
    font-size: 14px;
    font-weight: 520;
}

.default-address-detailed-span{
    color: rgba(253, 123, 17, 0.879);
}

.non-default-address-detailed-span{
    color: rgba(0, 0, 0, 0.879);
}

.address-detailed-span{
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
    flex: 0 0 auto; /* 保持元素的自然宽度，不伸展或压缩 */
    max-width: 100%; /* 限制最大宽度，防止超出容器 */
    text-align: left; 
}

.default-address-user-span{
    color: rgba(253, 123, 17, 0.879);
    text-align: left; 
}

.non-default-address-user-span{
    color: rgba(26, 7, 7, 0.879);
    text-align: left; 
}

.address-user-span{
    font-size: 15px;
    font-weight: 520;
}

.address-default-span{
    border: 1px solid #ccc; /* 边框颜色 */
  padding: 1px 3px; /* 内边距 */
  border-radius: 2px; /* 圆角边框 */
    color: rgba(255, 101, 6, 0.879);
    font-size: 15px;
    font-weight: 600;
    margin-left: 13px;
    background-color: rgb(247, 204, 143);
}

.info-last-line{
    display: flex;
    justify-content: flex-start;
}

.default-address  {
  color: #b8860b;
  background-color: rgb(251, 244, 231);
}

.manage-actions {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.action-btn {
  border: none;
  background-color: transparent;
  color: #666;
  cursor: pointer;
}

.default-background {
    background-color: rgb(251, 244, 231);
}

.non-default-background {
  background-color: #fff;
}

.edit-btn {
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  cursor: pointer;
}
</style>